import React from 'react';
import { Section } from './ui/Section';
export function NotForYou() {
  const points = ['Buscas "pasitos" de Instagram.', 'Crees que bailar bien es igual a saber enseñar.', 'No te importa perder 5 horas a la semana planificando.'];
  return <Section variant="alt" data-id="element-211">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-212">
        ❌ ESTE MANUAL NO ES PARA TI SI...
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-213">
        {points.map((point, i) => <div key={i} className="bg-gradient-card border border-red-500/30 rounded-xl p-6 flex items-start gap-4" data-id="element-214">
            <span className="text-red-400 text-2xl shrink-0" data-id="element-215">❌</span>
            <p className="text-brand-text font-medium" data-id="element-216">{point}</p>
          </div>)}
      </div>
    </Section>;
}